import React, { useState } from 'react';
import config from '../../config/config';
import { t } from '../../util/messages';
import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import { TopbarContainer } from '..';
import css from './TermsOfServicePage.module.css';

const TermsOfServicePage = () => {
  const [scrollingDisabled, setScrollingDisabled] = useState(false);

  const onManageDisableScrolling = (_id, disabled = false) => {
    setScrollingDisabled(disabled);
  };

  const schemaTitle = t('TermsOfServicePage.title', { siteTitle: config.siteTitle });
  const schemaDescription = t('TermsOfServicePage.schemaDescription');

  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      description={schemaDescription}
      schema={{
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
        description: schemaDescription,
        url: `${config.canonicalRootURL}/terms-of-service`,
      }}>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer onManageDisableScrolling={onManageDisableScrolling} />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.root}>
            <div className={css.content}>
              <article className={css.legalContainer}>
                <h1>Terms and Conditions of Use</h1>
                <p className={css.lastUpdated}>Last Updated: January 16, 2026</p>
                <p>
                  These Terms and Conditions of Use ("Terms") govern your access to and
                  use of the website <strong>https://gitribe.com</strong> ("Website"),
                  operated by <strong>Gitribe</strong>. By accessing or using this
                  Website, you agree to be bound by these Terms and all applicable laws
                  and regulations.
                </p>
                <p>
                  If you do not agree with any part of these Terms, you must discontinue
                  use of the Website immediately.
                </p>

                <h2>Use of the Website</h2>
                <p>
                  You may use this Website only for lawful purposes and in a manner that
                  does not infringe the rights of others. You agree not to:
                </p>
                <ul>
                  <li>Violate any applicable laws or regulations</li>
                  <li>Engage in fraudulent, deceptive, or dishonest behavior</li>
                  <li>Attempt unauthorized access to systems or data</li>
                  <li>Upload or transmit malicious software, viruses, or harmful code</li>
                  <li>Send unsolicited or unauthorized promotional communications</li>
                </ul>

                <h2>Intellectual Property</h2>
                <p>
                  All content on this Website, including text, graphics, logos, visuals,
                  layouts, and code, is the intellectual property of Gitribe or its
                  licensors and is protected by applicable intellectual property laws.
                </p>

                <h2>Access and Use Restrictions</h2>
                <p>
                  Permission is granted solely to view the materials on this Website.
                  This permission does not permit you to:
                </p>
                <ul>
                  <li>Download, modify, copy, or redistribute Website content</li>
                  <li>Use materials for personal or commercial purposes</li>
                  <li>Reverse engineer or decompile any software</li>
                  <li>Remove copyright or proprietary notices</li>
                </ul>

                <h2>Disclaimer</h2>
                <p>
                  The Website and its content are provided on an "as is" and "as
                  available" basis. Gitribe makes no warranties regarding the
                  availability, accuracy, reliability, or suitability of the Website.
                </p>

                <h2>Limitation of Liability</h2>
                <p>
                  To the maximum extent permitted by law, Gitribe shall not be liable
                  for any direct, indirect, incidental, consequential, or special
                  damages arising from the use or inability to use this Website.
                </p>

                <h2>Third-Party Links</h2>
                <p>
                  The Website may contain links to third-party websites for
                  informational purposes. Gitribe does not control or endorse these
                  websites and is not responsible for their content or practices.
                </p>

                <h2>Modifications</h2>
                <p>
                  Gitribe reserves the right to revise or update these Terms at any
                  time. Continued use of the Website constitutes acceptance of the
                  updated Terms.
                </p>

                <h2>Governing Law</h2>
                <p>
                  These Terms shall be governed by and interpreted in accordance with
                  applicable laws, without regard to conflict of law principles.
                </p>

                <h2>Contact</h2>
                <p>
                  If you have any questions regarding these Terms, please contact us at{' '}
                  <a href="mailto:contact@gitribe.com">contact@gitribe.com</a>.
                </p>
              </article>
            </div>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <div className={css.footerContainer}>
            <Footer />
          </div>
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

export default TermsOfServicePage;
